<template>
    <div class="about">
        <pubHeader></pubHeader>
        <aboutBanner></aboutBanner>
        <div class="maxmain">
            <div class="aboutCenter">
                <h1>关于我们</h1>
                <div class="OverallBox">
                    chengwei@zhongkesd.com
                </div>
            </div>
        
            <div class="aboutCenter">
                <h1>联系我们</h1>
                <div class="OverallBox">
                    <div v-for="(val,index) in Overall" :key="index">
                        <p>
                            <span>
                                {{val.name}}
                            </span>
                        </p>
                        {{val.detail}}
                    </div>
                </div>
            </div>
        </div>
        
        <pubFooter></pubFooter>
    </div>
</template>
<script>
import pubHeader from "@/components/pubHeader"
import pubFooter from "@/components/pubFooter"
import aboutBanner from "./aboutBanner"
export default {
    name: "about",
    components: {pubHeader,aboutBanner,pubFooter},
    data(){
        return{
            Overall:[
                { name: "联系电话",img: "@/assets/img/jiankangfuwu@2x.png",detail:"010-82177422" },
                { name: "公司地址",img: "@/assets/img/jiankangfuwu@2x.png",detail:"海淀区上地信息产业基地三街1号楼2层215" },
                { name: "公司网址",img: "@/assets/img/jiankangfuwu@2x.png",detail:"http://www.xyshe.com.cn" },
            ]
        }
    }
}
</script>
<style lang="scss" scoped>

.about{
    width: 100%;
    min-width: 1024px;
    overflow: hidden;
    @media screen and (max-width: 991px){ 
        .pubFooter{
            width: 100%;
            position: fixed;
            bottom: 0;
            left: 0;
            right: 0;
        }
    }
    .OverallBox{
        width: 60.25%;
        display: flex;
        justify-content: space-between;
        margin-top: 20px;
        font-size: 14px;
        >div{
            width: 30%;
            border:1px solid #000000;
            padding: 30px 20px 10px 20px;
            position: relative;
            font-size: 12px;
            display: flex;
            align-items: center;
            justify-content: center;
            p{
                width: 80%;
                display: inline-block;
                position: absolute;
                left: 10%;
                top: -25px;
                height: 50px;
                background: #ffffff;
                padding: 3px;
                span{
                    width: 100%;
                    height: 100%;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }
            }
        }
    }
    .aboutCenter{
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding: 40px 0;
        h1{
            font-size: 20px;
            color: #333333;
            text-align: center;
            padding: 0 0 20px 0;
        }
        
    }
    
}
</style>